import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// Button is defined as styled component below, removing unused import
// import Button from "../../../components/Buttons/Button";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import { getUserInfo, getUserRolePermissions, getUsers } from 'src/services/userServicer';
import Select from 'react-select';
import { getControls } from "src/services/controls";
import { useForm } from "react-hook-form";
import { MdOutlineDelete } from "react-icons/md";
import { createSurvey,fetchAllDataApi, getSurveyQuestionByQuarterByPage } from "src/services/question"
import { useNavigate, useParams } from 'react-router-dom';
import i18n from "src/i18n";
import styled from 'styled-components';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { CiExport, CiFilter } from "react-icons/ci";
const ExportSurvey = () => {
  const { t } = useTranslation();
 
  const { id } = useParams();
  const [notAllowed, setNotAllowed] = useState(false);
  const [questions, setQuestions] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // State for quarter and year
  const [selectedQuarter, setSelectedQuarter] = useState('Q1');
  const [selectedYear, setSelectedYear] = useState(2024);

  // Options for quarter and year
  const quarterOptions = [
    { value: 'Q1', label: 'Q1' },
    { value: 'Q2', label: 'Q2' },
    { value: 'Q3', label: 'Q3' },
    { value: 'Q4', label: 'Q4' },
  ];

  const yearOptions:any = Array.from({ length: 10 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year, label: year.toString() };
  });

  


  // Function to filter data based on selected quarter and year
  const filterData = async () => {
    const response = await getSurveyQuestionByQuarterByPage(id,selectedQuarter,selectedYear,page,pageSize);
    
    if(response.success){
    setQuestions(response?.data?.result);
    setTotalPages(response?.data?.totalPages);
    }
    else{
      toast.error(response.message);
    }
  };



  const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
 

   th {
    background-color: black; /* Black header */
    color: white; /* White text for header */
  }




  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  tr:hover {
    background-color: #ddd;
  }
`;

const Button = styled.button`
  margin: 20px 0;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #45a049;
  }
`;

// Column colors
const columnColors = {
  QID: '#ADD8E6', // Light Blue for QID
  Category: '#fff', // Light Green for Category
  Question: '#fff', // Gold for Question
  Owner: '#fff', // Light Salmon for Owner
  RiskLevels: '#fff', // Tomato for Risk Levels
};

// Risk level colors
const riskLevelColors = {
  Most: 'C00000',       // Red for "Most"
  Significant: 'FF0000', // Orange for "Significant"
  Moderate: 'FFC000',    // Yellow for "Moderate"
  Minimal: '00B050',     // Light Blue for "Minimal"
  Least: '92D050',       // Light Green for "Least"
 'N/A': 'FFFFFF',         // White for "N/A"
};

const riskLevelColorsForTable = {
  Most: '#C00000',       // Red for "Most"
  Significant: '#FF0000', // Orange for "Significant"
  Moderate: '#FFC000',    // Yellow for "Moderate"
  Minimal: '#00B050',     // Light Blue for "Minimal"
  Least: '#92D050',       // Light Green for "Least"
  'N/A': '#FFFFFF',         // White for "N/A"
};




  const exportToExcel = async() => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Inherent Risk Profile');

    const response = await getSurveyQuestionByQuarterByPage(id,selectedQuarter,selectedYear,0,500);
    
    if(response.success){
      const data:any = response?.data?.result;
      const data2:any = data.map((row:any,index:any) => ({
        qid: index+1,
        category: row?.question?.category?.name,
        question: row?.question?.question_en,
        owner: row?.user?.name,
        riskLevel: row?.answer
      }));

     
   
    // Add headers with styling
    worksheet.columns = [
      { header: 'QID', key: 'qid', width: 10, style: { alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFADD8E6' } }, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } } },
      { header: 'Category', key: 'category', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }, fill: { type: 'pattern', pattern: 'solid'}, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } } },
      { header: 'Question', key: 'question', width: 80, style: { alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }, fill: { type: 'pattern', pattern: 'solid'}, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } } },
      { header: 'Owner', key: 'owner', width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }, fill: { type: 'pattern', pattern: 'solid'}, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } } },
      { header: 'Risk Levels (Bank Response)', key: 'riskLevel', width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }, fill: { type: 'pattern', pattern: 'solid' }, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } } },
    ];

    // Set header row height
    worksheet.getRow(1).height = 30;


    



    // Style the header row
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell:any) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '000000' }, // Black background
      };
      cell.font = {
        color: { argb: 'FFFFFF' }, // White text
        bold: true,
      };
    });

    // Add data rows and style the "Risk Levels" column
    data2.forEach((row:any) => {
      const newRow = worksheet.addRow(row);
      const riskLevelCell = newRow.getCell('riskLevel');
      riskLevelCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: riskLevelColors[row.riskLevel as keyof typeof riskLevelColors] || 'FFFFFF' }, // Dynamic color
      };
    });

   
  
    
  
    // Save the file
    workbook.xlsx.writeBuffer()?.then((buffer:any) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'InherentRiskProfile.xlsx');
    });

   
    }
    else{
      toast.error(response.message);
    }
  
  };
 
 
  useEffect(() => {
    filterData();
  }, [pageSize, page,selectedQuarter,selectedYear]);

  // Custom styles for react-select to reduce height
  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '50px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '40px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '40px',
    }),
  };

  return (
    <div className="root">
      <Breadcrumb>
        <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
        <BreadcrumbItem>{t("surveys.Surveys")}</BreadcrumbItem>
        <BreadcrumbItem active style={{ paddingRight: '10px' }}>
          {t("surveys.Export Survey")}
        </BreadcrumbItem>
      </Breadcrumb>

      <h5 className="mb-lg">{t('surveys.Export Survey')}</h5>
      {!notAllowed && <div className="container_info">
        <div className="d-flex flex-wrap mb-3">
          <div className="flex-grow-1" style={{ flexBasis: 'calc(25% - 10px)', margin: '5px' }}>
            <Select
              options={quarterOptions}
              styles={customSelectStyles}
              placeholder={t("question.Select Quarter")}
              onChange={(option:any) => setSelectedQuarter(option?.value || '')}
            />
          </div>
          <div className="flex-grow-1" style={{ flexBasis: 'calc(25% - 10px)', margin: '5px' }}>
            <Select
              options={yearOptions}
              styles={customSelectStyles}
              placeholder={t("question.Select Year")}
              onChange={(option:any) => setSelectedYear(option?.value || 0)}
            />
          </div>
          <div className="flex-grow-1" style={{ flexBasis: 'calc(20% - 10px)', margin: '10px' }}>
            <button className="submit-button5 mr-2 ml-2" onClick={filterData}><CiFilter /> {t("surveys.Filter")}</button>
         
            <button className="submit-button5  mr-2 ml-2" onClick={exportToExcel}> <CiExport /> {t("surveys.Export to Excel")}</button>
          </div>
        </div>

        {/* Styled components for the table and button */}
        <div>
          <Table>
            <thead>
              <tr style={{ backgroundColor: 'black', color: 'white' }}>
                <th>QID</th>
                <th>Category</th>
                <th>Question</th>
                <th>Owner</th>
                <th>Risk Levels (Bank Response)</th>
              </tr>
            </thead>
            <tbody>
              {questions.map((row:any, index:any) => (
                <tr key={index}>
                  <td style={{ textAlign:'center',backgroundColor: columnColors.QID }}>{index+1}</td>
                  <td style={{ textAlign:'center',backgroundColor: columnColors.Category }}>{row?.question?.category?.name}</td>
                  <td style={{ backgroundColor: columnColors.Question }}>{row?.question?.question_en}</td>
                  <td style={{ textAlign:'center',backgroundColor: columnColors.Owner }}>{row?.user?.name}</td>
                  <td style={{textAlign:'center',backgroundColor: riskLevelColorsForTable[row?.answer as keyof typeof riskLevelColorsForTable] }}>{row?.answer}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          
        </div>
          {/* Pagination */}
       <div className="pagination-controls mt-3">
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage(0)}
                  disabled={page ===0}
                >
                  {"<<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage((prev) => Math.max(prev - 1,0))}
                  disabled={page === 0}
                >
                  {"<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage((prev) =>
                      Math.min(
                        prev + 1,
                        totalPages-1
                      )
                    )
                  }
                  disabled={
                    page >= totalPages-1 
                  }
                >
                  {">"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage(
                      totalPages-1
                    )
                  }
                  disabled={
                    page >= totalPages-1 
                  }
                >
                  {">>"}
                </button>{" "}
                <span>
                  {t("question.page")}
                   {page+1} {t("question.to")} {totalPages}
                </span>
              </div>
      </div>}

      {notAllowed && <div className="container_info">
        <div className="d-flex justify-content-between my-2 text-center alert alert-danger">
          <h5 style={{ width: '100%' }} className="text-center">{t("permissions.not_allowed")}</h5>
        </div>
      </div>}
    </div>
  );
};

export default ExportSurvey;